<nb-card class="exercise-dialog">
  <nb-card-header>
    <h5>
      {{
        mode === "kb"
          ? ("pages.dozent.exerciseDialog.titleKb" | translate)
          : mode === "topic"
            ? ("pages.dozent.exerciseDialog.titleTopic" | translate)
            : ("pages.dozent.exerciseDialog.titleScratch" | translate)
      }}
    </h5>
    <span class="step-indicator">
      {{ step }} / {{ totalSteps }}
    </span>
  </nb-card-header>

  <nb-card-body>
    <!-- Step 1: Basic Info -->
    <form *ngIf="step === 1" class="step-content" [formGroup]="basicsForm">
      <div class="form-row">
        <label for="exercise-title">{{ "input.name.label" | translate }} *</label>
        <input
          id="exercise-title"
          nbInput
          fullWidth
          formControlName="title"
          alAnchor="exercise.title"
          placeholder="{{ 'pages.dozent.exercises.titlePlaceholder' | translate }}"
        />
      </div>

      <div class="form-row">
        <label for="exercise-description">{{ "input.description.label" | translate }} *</label>
        <textarea
          id="exercise-description"
          nbInput
          fullWidth
          formControlName="description"
          alAnchor="exercise.description"
          rows="2"
          placeholder="{{ 'pages.dozent.exercises.descriptionPlaceholder' | translate }}"
        ></textarea>
        <!-- Static hint (KB mode only) — never toggles, so the dialog keeps
             its size while typing. Required-feedback itself is the global
             red border + shake. -->
        <p class="hint-text" *ngIf="mode === 'kb'">
          {{ "pages.dozent.exerciseDialog.descriptionRequired" | translate }}
        </p>
        <p class="hint-text" *ngIf="mode === 'topic'">
          {{ "pages.dozent.exerciseDialog.descriptionTopic" | translate }}
        </p>
      </div>

      <div class="form-row">
        <label for="exercise-learning-goals">{{ "pages.dozent.exerciseDialog.learningGoals" | translate }}</label>
        <textarea
          id="exercise-learning-goals"
          nbInput
          fullWidth
          formControlName="learningGoals"
          rows="2"
          placeholder="{{ 'pages.dozent.exerciseDialog.learningGoalsPlaceholder' | translate }}"
        ></textarea>
      </div>
    </form>

    <!-- Step 2: Exercise Parameters -->
    <form *ngIf="isParamsStep" class="step-content" [formGroup]="paramsForm">
      <div class="form-row-group">
        <div class="form-row">
          <label>{{ "pages.dozent.exercises.type" | translate }} *</label>
          <nb-select formControlName="exerciseTypes" multiple fullWidth alAnchor="exercise.types">
            <nb-option *ngFor="let t of exerciseTypes" [value]="t.value">
              {{ t.label }}
            </nb-option>
          </nb-select>
        </div>

        <div class="form-row">
          <label>{{ "pages.dozent.exerciseDialog.difficulty" | translate }}</label>
          <nb-select formControlName="difficultyLevel" fullWidth>
            <nb-option *ngFor="let d of difficultyLevels" [value]="d.value">
              {{ d.labelKey | translate }}
            </nb-option>
          </nb-select>
        </div>
      </div>

      <div class="form-row-group">
        <div class="form-row">
          <label>{{ "pages.dozent.exerciseDialog.scope" | translate }}</label>
          <nb-select formControlName="scope" fullWidth>
            <nb-option *ngFor="let s of scopeOptions" [value]="s.value">
              {{ s.labelKey | translate }}
            </nb-option>
          </nb-select>
        </div>

        <div class="form-row">
          <label for="exercise-max-score">{{ "pages.dozent.exercises.maxScore" | translate }} *</label>
          <input id="exercise-max-score" nbInput type="number" fullWidth formControlName="maxScore" />
        </div>
      </div>
    </form>

    <!-- Step 2 (KB mode only): Knowledge Base Selection -->
    <div *ngIf="isKbSelectionStep" class="step-content">
      <div class="form-row">
        <label>{{ "pages.dozent.exerciseDialog.selectKbs" | translate }}</label>
      </div>

      <div class="kb-list" *ngIf="connectedBuckets.length > 0" alAnchor="exercise.kb-list">
        <div
          *ngFor="let bucket of connectedBuckets"
          class="kb-item"
          [class.selected]="isBucketSelected(bucket.id)"
          (click)="toggleBucket(bucket.id)"
        >
          <nb-checkbox
            [checked]="isBucketSelected(bucket.id)"
            (click)="$event.stopPropagation()"
            (checkedChange)="toggleBucket(bucket.id)"
          ></nb-checkbox>
          <div class="kb-info">
            <span class="kb-name">{{ bucket.name }}</span>
            <span class="kb-desc" *ngIf="bucket.description || bucket.lms_source">
              {{ bucket.description || ('pages.knowledgeBase.syncFolderDescription.' + bucket.lms_source | translate) }}
            </span>
          </div>
        </div>
      </div>

      <p
        class="hint-text"
        *ngIf="connectedBuckets.length === 0"
      >
        {{ "pages.dozent.exerciseDialog.noKbsAvailable" | translate }}
      </p>

      <!-- Always in the DOM (hidden via visibility) so picking a KB doesn't
           add a line and resize the dialog. -->
      <p
        class="selected-count"
        *ngIf="connectedBuckets.length > 0"
        [class.is-empty]="selectedBucketIds.length === 0"
        aria-live="polite"
      >
        {{ selectedBucketIds.length }} {{ "pages.dozent.exerciseDialog.kbsSelected" | translate }}
      </p>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button nbButton ghost (click)="step > 1 ? prevStep() : close()">
      {{ step > 1 ? ("buttons.back" | translate) : ("buttons.cancel" | translate) }}
    </button>
    <button
      nbButton
      status="primary"
      (click)="nextStep()"
      [disabled]="!canProceed()"
    >
      {{
        step < totalSteps
          ? ("buttons.next" | translate)
          : mode === "kb" || mode === "topic"
            ? ("pages.dozent.exerciseDialog.generateInCreator" | translate)
            : ("buttons.create" | translate)
      }}
    </button>
  </nb-card-footer>
</nb-card>
